import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { Base64Service } from "@app/services/base64.service";
import { DialogService } from "@app/services/dialog.service";
import { DrawerService } from "@app/services/drawer.service";
import { IRootScope } from "@models";
import { StateService } from "@uirouter/core";

/**
 * Acts as an aggregate service so consolidate dependencies used
 * across the crudController inherited classes
 */
@NgService({
    token: Token.SearchService,
    dependencies: [
        Token.$Location,
        Token.$State,
        Token.$Http,
        Token.$RootScope,
        Token.DialogService,
        Token.DrawerService,
        Token.$Timeout,
        Token.$Q,
        Token.ApiService,
        Token.Base64Service,
        Token.$Filter
    ]
})
export class SearchService {
    constructor(
        public $location: ng.ILocationService,
        public $state: StateService,
        public $http: ng.IHttpService,
        public $rootScope: IRootScope,
        public dialogService: DialogService,
        public drawerService: DrawerService,
        public $timeout: ng.ITimeoutService,
        public $q: ng.IQService,
        public api: ApiService,
        public base64Service: Base64Service,
        public $filter: ng.IFilterService
    ) {

    }
}
